export function parseJson<T = unknown>(text: string): T {
  const hijackPreventionPrefix = ")]}',";
  if (text.startsWith(hijackPreventionPrefix)) {
    return JSON.parse(text.slice(hijackPreventionPrefix.length)) as T;
  }
  return JSON.parse(text.trim()) as T;
}
